module.exports = __webpack_public_path__ + "img/_newzealand.9636477a.png";